import React, { useEffect } from "react";
import "./styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { colors } from "../../common/pallette/colors";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setGlobalFiltersCount,
} from "../../redux/reducers/common";

interface FilterBoxProps {
  isOpen: boolean;
  onToggle: () => void;
}

const FilterBox = ({ isOpen, onToggle }: FilterBoxProps) => {
  const dispatch = useDispatch();
  const globalFiltersCount = useSelector(
    (state: any) => state.common.globalFiltersCount
  );
  const selectedClubs = useSelector((state: any) => state.common.clubNameFilter);
  const selectedLeagues = useSelector((state: any) => state.common.leagueFilter);
  const selectedStars = useSelector((state: any) => state.common.starRatingFilter);
  const selectedTargetStars = useSelector(
    (state: any) => state.common.targetStarRatingFilter
  );

  useEffect(() => {
    let count = 0;
    if (selectedClubs.length > 0) count++;
    if (selectedLeagues.length > 0) count++;
    if (selectedStars.length > 0) count++;
    if (selectedTargetStars.length > 0) count++;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dispatch(setGlobalFiltersCount(count));
  }, [selectedClubs, selectedLeagues, selectedStars, selectedTargetStars, dispatch]);

  return (
    <div
      className="filterBox pointer"
      style={{
        backgroundColor: isOpen ? `${colors.blue.navy}15` : colors.grey.light,
        border: isOpen ? `1px solid ${colors.blue.navy}40` : "1px solid transparent",
        transition: "background-color 0.15s, border-color 0.15s",
      }}
      onClick={onToggle}
    >
      <div className="filterButton">
        <FontAwesomeIcon
          className="filterIcon icon"
          icon={faFilter}
          style={{ color: isOpen ? colors.blue.navy : colors.grey.dark }}
        />
        <span style={{ color: isOpen ? colors.blue.navy : colors.grey.dark }}>
          Filters
        </span>
      </div>
      {globalFiltersCount > 0 && (
        <Box
          className={"filterCount"}
          sx={{ backgroundColor: colors.blue.navy }}
        >
          {globalFiltersCount}
        </Box>
      )}
    </div>
  );
};

export default FilterBox;
